<template>
  <p
    v-if="url"
    class="labeled-external-link">
    {{ label }}<br>
    <a
      :href="url"
      target="_blank"
      rel="noopener noreferrer"
      v-bind="$attrs">{{ url }}</a>
  </p>
</template>

<script>
/**
 * @description ラベル付きで外部ページへのリンクを表示する
 * URL が空のときは何も表示しない（リンク先が未確定の場合に使う）
 */
export default {
  // data-testid などの属性はルートの <p> ではなくリンク自体に付ける
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.labeled-external-link {
  margin: 8px 0 0;
  font-size: $fs-s;
  color: $l-blue;
  line-height: 1.6;
  word-break: break-all;
}
</style>
